module.exports = __webpack_public_path__ + "images/emoji/clock1.e5c629f4ab9c01050d7d.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/clock1.png
// module id = 7srR
// module chunks = 14